import { render, staticRenderFns } from "./ResourceDetailLoader.vue?vue&type=template&id=0c4d09bb&"
import script from "./ResourceDetailLoader.vue?vue&type=script&lang=ts&"
export * from "./ResourceDetailLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports